module.exports = __webpack_public_path__ + "static/media/browserconfig.653d0773.xml";